import { render } from "./HeroiconsOutlineCalendar.vue?vue&type=template&id=61be856b"
const script = {}

import exportComponent from "/var/app/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCalendar.vue"]])

export default __exports__